import {
  resolveCartItemPrice,
  resolveGiftMessage,
  resolveGiftOptionId
} from "./utils.mjs";
export function mapCartItem(apiItem) {
  const baseProductPrice = apiItem && apiItem?.product && apiItem?.product?.special_price && apiItem?.product?.special_to_date ? resolveProductPrice(apiItem.product) : 0;
  const unitPrice = apiItem?.prices?.price.value || baseProductPrice;
  const totalPrice = apiItem?.prices?.row_total.value || baseProductPrice * (apiItem?.quantity ?? 1);
  const totalDiscount = apiItem?.prices?.total_item_discount?.value ?? 0;
  const oldPrice = apiItem?.product?.price_range?.maximum_price?.regular_price.value ?? 0;
  const giftBoxOptionId = (apiItem && resolveGiftOptionId(apiItem))?.toString() || "";
  const giftBoxMessage = apiItem && resolveGiftMessage(apiItem) || "";
  const configurationOptions = apiItem?.__typename === "ConfigurableCartItem" ? apiItem?.configurable_options?.map((option) => {
    return { label: option?.option_label, value: option?.value_label };
  }) : [];
  return {
    type: apiItem?.product?.__typename || "",
    id: apiItem?.uid || "",
    quantity: apiItem?.quantity || 1,
    name: apiItem?.product?.name || "",
    unitPrice,
    totalPrice,
    totalDiscount,
    oldPrice,
    sku: apiItem?.product?.sku || "",
    isPendingRemoval: false,
    slug: apiItem?.product?.url_key,
    stock: apiItem?.product && resolveCartItemPrice(apiItem?.product),
    image: {
      src: apiItem?.product?.thumbnail?.url || "",
      alt: apiItem?.product?.thumbnail?.label ?? (apiItem?.product?.name || "")
    },
    cartControl: {
      max: Number(apiItem?.product?.cart_control?.max_amount) ?? Number.MAX_VALUE,
      // maximum quantity allowed in the cart
      min: Number(apiItem?.product?.cart_control?.min_amount) ?? 0,
      // minimum quantity allowed in the cart
      step: Number(apiItem?.product?.cart_control?.increment_step) ?? 1
      // quantity step
    },
    url: apiItem?.product?.url_key || "",
    brand: apiItem?.product?.brand?.name || "",
    configurationOptions,
    // Use Configurable Cart Item keys to overwrite apiItem?.product keys
    ...apiItem?.__typename === "ConfigurableCartItem" ? apiItem?.configured_variant && mapConfiguredVariant(apiItem?.configured_variant) : {},
    /**
     * Property to check if the cart item is able to be change item quantity
     */
    allowChangeQuantity: checkIfItemIsAbleToChange(apiItem),
    /**
     * Property to show that if the product is available or not
     */
    isInvalidItem: isInvalidItem(apiItem),
    giftBoxOptionId,
    giftBoxMessage
  };
}
function mapConfiguredVariant(product) {
  return {
    name: product.name || "",
    image: {
      src: product.thumbnail?.url || "",
      alt: product.thumbnail?.label ?? (product.name || "")
    },
    stock: product.only_x_left_in_stock || 0,
    sku: product.sku || "",
    unitPrice: product?.price_range?.maximum_price?.final_price.value ?? 0,
    oldPrice: product?.price_range?.maximum_price?.regular_price.value ?? 0
  };
}
function checkIfItemIsAbleToChange(item) {
  return item?.__typename !== "BundleCartItem";
}
function isInvalidItem(item) {
  if (item?.__typename === "BundleCartItem") {
    return false;
  }
  const stock = item?.__typename === "ConfigurableCartItem" ? item?.configured_variant?.only_x_left_in_stock || 0 : item?.product.only_x_left_in_stock || 0;
  return stock < (item?.quantity || 1);
}
